export enum RoleTypeEnum {
    coach = "COACH",
    athlete = "ATHLETE",
}
